<h2 class="fo-dialog-content" mat-dialog-title>
  {{ 'hr.invite-employee-date-range-form-title' | translate }}
</h2>
<mat-dialog-content>
  <span class="date-range-description">{{
    'hr.invite-employee-date-range-form-message' | translate
  }}</span>
  <div fxLayout="row" fxLayoutGap="20px" [formGroup]="form">
    <mat-form-field fxFlex="1 0">
      <mat-label>{{ 'general.date-from' | translate }}</mat-label>
      <input formControlName="fromDate" matInput [matDatepicker]="fromDate" />
      <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
      <mat-datepicker #fromDate></mat-datepicker>
    </mat-form-field>
    <mat-form-field fxFlex="1 0">
      <mat-label>{{ 'general.date-to' | translate }}</mat-label>
      <input formControlName="toDate" matInput [matDatepicker]="toDate" [min]="minToDate()" />
      @if (form.hasError('dateRangeInvalid')) {
        <mat-error>
          {{ 'general.date-range-invalid' | translate }}
        </mat-error>
      }
      <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
      <mat-datepicker #toDate></mat-datepicker>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="fo-dialog-actions fo-dialog-actions_small">
    <button matButton="filled" (click)="onCancel()">
      {{ 'general.cancel' | translate }}
    </button>
    <span
      [matTooltip]="inviteBlockedTooltipKey ? (inviteBlockedTooltipKey | translate) : ''"
      [matTooltipDisabled]="!isInviteBlocked"
    >
      <button
        matButton="filled"
        [disabled]="form.invalid || isInviteBlocked"
        (click)="onSave()" class="fo-color-secondary"
      >
        {{ 'general.save' | translate }}
      </button>
    </span>
  </div>
</mat-dialog-actions>
